import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { ACRState } from "@reducers/types/HRM/acr-state";

import {
  createACRRequest,
  getACRHistoryRequest,
  deleteACRHistoryRequest,
} from "@actions/HRM/employee/acr-actions";
import { getACRState } from "@selectors/HRM/employee/acr-selector";

import { useAppSelector } from "@helpers/redux";
import { AcrType } from "@type/HRM/acr";

interface UseACR {
  getAcrHistoryRequestOngoing: boolean;
  getAcrHistorySuccess: boolean;
  getAcrHistoryFailed: boolean;
  deleteAcrHistoryRequestOngoing: boolean;
  deleteAcrHistorySuccess: boolean;
  deleteAcrHistoryFailed: boolean;
  createAcrRequestOngoing: boolean;
  createAcrSuccess: boolean;
  createAcrFailed: boolean;
  acr: AcrType[];
  createACR: (data: AcrType) => void;
  deleteACRHistory: (acrID: number) => void;
}

export const useACR = (id: string | number | null): UseACR => {
  const dispatch = useDispatch();
  const {
    data,
    getAcrHistoryRequestOngoing,
    getAcrHistorySuccess,
    getAcrHistoryFailed,
    deleteAcrHistoryRequestOngoing,
    deleteAcrHistorySuccess,
    deleteAcrHistoryFailed,
    createAcrRequestOngoing,
    createAcrSuccess,
    createAcrFailed,
  } = useAppSelector<ACRState>(getACRState);

  useEffect(() => {
    dispatch(getACRHistoryRequest(id));
  }, [dispatch, id]);

  const acr = data || [];

  const createACR = (data: AcrType) => {
    dispatch(
      createACRRequest({
        ...data,
        employeeID: id,
      })
    );
  };

  const deleteACRHistory = (acrID: number) => {
    dispatch(
      deleteACRHistoryRequest({
        employeeID: id,
        acrID,
      })
    );
  };
  return {
    acr,
    createAcrFailed,
    createAcrRequestOngoing,
    createAcrSuccess,
    deleteAcrHistoryFailed,
    deleteAcrHistoryRequestOngoing,
    deleteAcrHistorySuccess,
    getAcrHistoryFailed,
    getAcrHistoryRequestOngoing,
    getAcrHistorySuccess,

    createACR,

    deleteACRHistory,
  };
};
